import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/delete-box.svg'


const _withScopeId = n => (_pushScopeId("data-v-36185b43"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"agreement-img\" data-v-36185b43><img src=\"" + _imports_0 + "\" alt=\"close\" class=\"w-auto\" data-v-36185b43></div><div class=\"modal-header\" data-v-36185b43><div class=\"modal-title\" data-v-36185b43> Are you sure you want to delete this dependent&#39;s details? </div></div><div class=\"modal-body\" data-v-36185b43> Deleting the dependent&#39;s information will remove all associated data and may impact their access to benefits. Please confirm your decision to proceed with the deletion. </div>", 3)
const _hoisted_7 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal fade", { 'show d-block': _ctx.visible }]),
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isFormInvalid)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "alert alert-danger",
            innerHTML: _ctx.validationMsg
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
          "aria-label": "Close"
        }),
        _hoisted_4,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn text-primary me-sm-3",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, " CANCEL "),
          _createElementVNode("button", {
            type: "button",
            id: "button-confirm",
            class: "btn btn-primary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteDependent && _ctx.deleteDependent(...args)))
          }, " CONFIRM ")
        ])
      ])
    ])
  ], 2))
}